import { Icon } from './icon';

export function PageTitle({ text, subtext, iconClass }: { text: string; subtext?: string; iconClass?: string }) {
  return (
    <div>
      <h1 className="flex items-center gap-4 font-serif text-2xl font-medium">
        {iconClass && <Icon className={`${iconClass} -mb-1 text-xl text-gray-500`} />}
        {text}
      </h1>
      {subtext && <p className="my-3 text-gray-600">{subtext}</p>}
    </div>
  );
}
